import type { FirebaseRepository } from './FirebaseRepository'
import { PromotionType, type MobxDocument } from '../types'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  type FirestoreSectionPromotion,
} from '../firestore/SectionPromotion'
import { computed } from 'mobx'

export class SectionPromotion extends ObservableModelWithDecorators<FirestoreSectionPromotion> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreSectionPromotion>
  ) {
    super(repository, doc)
  }

  @computed
  get promotionType() {
    const validPromotionTypes = Object.values(PromotionType)

    if (
      this.data.promotionId &&
      validPromotionTypes.includes(this.data.promotionId as PromotionType)
    )
      return this.data.promotionId as PromotionType

    return 'unknown'
  }
}
